export default "__VITE_ASSET__BQKsNNha__"